import React, { useEffect } from 'react';
import { Dropdown } from '@trip-ux/components';
import { useState } from 'react';
import TableFilterAddButton from './TableFilterAddButton';
import TableFilterRemoveButton from './TableFilterRemoveButton';
import TableFilterInputField from './TableFilterInputField';
import TableFilterResetButton from './TableFilterResetButton';
import TableFilterSearchButton from './TableFilterSearchButton';
import TableFilterTitle from './TableFilterTitle';
import { useTranslation } from './translationContext';
import { saveStartingFieldsArr, selectStartingFieldsArr } from '@trip-ux/redux-store';
import { useDispatch, useSelector } from 'react-redux';

const isFieldVisible = (fieldOption, index, visibleSearchFields) => {
  return visibleSearchFields.indexOf(fieldOption) === -1 || visibleSearchFields[index] === fieldOption;
};

const dropDownList = function (index, filterOptions, labels, visibleSearchFields) {
  const visibleFieldOptions = filterOptions.filter(function (fieldOption) {
    return isFieldVisible(fieldOption, index, visibleSearchFields);
  });
  const fieldOptionsMap = (labels && labels.tablefilter && labels.tablefilter.fieldOptions) || {};
  return visibleFieldOptions.map(function (fieldOption) {
    return { label: fieldOptionsMap[fieldOption] || fieldOption, value: fieldOption };
  });
};

const removeFieldFromDropdownOptions = (visibleSearchFields, field, value) => {
  const fields = [...visibleSearchFields];
  const fieldIndex = fields.indexOf(field);
  if (fields.indexOf(field) !== -1) {
    fields.splice(fieldIndex, 1, value);
  }
  return fields;
};

const onChange = (value, visibleSearchFields, field, setVisibleSearchFields, setSearchAppliedIcon) => {
  const fields = removeFieldFromDropdownOptions(visibleSearchFields, field, value);
  setVisibleSearchFields(fields);
  setSearchAppliedIcon(false);
};

const TableFilterForm = ({ handleSubmit, startingFields, disableSubmit, form, filterConfiguration, handleReset }) => {
  const dispatch = useDispatch();
  const selectStartingFields = useSelector(selectStartingFieldsArr);
  const [showSearchAppliedIcon, setShowSearchAppliedIcon] = useState(false);
  const [visibleSearchFields, setVisibleSearchFields] = useState(Object.keys(startingFields));
  const { t } = useTranslation();

  const filterOptions = Object.keys(filterConfiguration);

  useEffect(() => {
    if (selectStartingFields.length > 0) {
      setVisibleSearchFields(selectStartingFields);
    }
  }, [ selectStartingFields]);

  function onSubmit() {
    handleSubmit();
    setShowSearchAppliedIcon(true);
    dispatch(saveStartingFieldsArr(visibleSearchFields));
  }

  return (
    <div className="policy-form-row" style={{ maxWidth: '800px' }}>
      <div className="row">
        <div className="col-xs-12 col-sm-10">
          <TableFilterTitle fieldLength={visibleSearchFields.length} />
          {visibleSearchFields.map((field, index) => (
            <div className="row" key={`form-fields-${field}`}>
              <div className="col-8 col-sm-4 order-1">
                <Dropdown
                  id={`${field}-drop`}
                  value={field}
                  isDisabled={false}
                  options={dropDownList(index, filterOptions, t(null), visibleSearchFields)}
                  className="filter-dropdown"
                  placeholder={''}
                  onChange={value =>
                    onChange(value, visibleSearchFields, field, setVisibleSearchFields, setShowSearchAppliedIcon)
                  }
                  name="drop"
                />
              </div>
              <div className="col-8 col-sm-6 order-3 order-sm-2">
                <TableFilterInputField
                  field={field}
                  filterConfiguration={filterConfiguration}
                  onChange={() => showSearchAppliedIcon && setShowSearchAppliedIcon(false)}
                />
              </div>
              <div className="col-4 col-sm-2 order-2 order-sm-3 p-0">
                <TableFilterRemoveButton
                  field={field}
                  visibleSearchFields={visibleSearchFields}
                  index={index}
                  setVisibleSearchFields={setVisibleSearchFields}
                  setSearchAppliedIcon={setShowSearchAppliedIcon}
                  form={form}
                  filterConfiguration={filterConfiguration}
                />
              </div>
              <div className="col-xs-12 col-sm-12 d-none d-sm-none d-md-none d-lg-none">
                <hr className=" hr-element" />
              </div>
            </div>
          ))}
          <div className="row search-row">
            <div className="col-xs-6 col-sm-6 my-3 p-0">
              <TableFilterAddButton
                disabledFlag={visibleSearchFields.length === filterOptions.length}
                visibleSearchFields={visibleSearchFields}
                setVisibleSearchFields={setVisibleSearchFields}
                filterOptions={filterOptions}
                setSearchAppliedIcon={setShowSearchAppliedIcon}
              />
            </div>
          </div>
          <div className="row search-row" style={{ alignItems: 'center' }}>
            <div className="col-xs-6 col-sm-4">
              <TableFilterSearchButton handleClick={onSubmit} disableSubmit={disableSubmit} />
            </div>
            <div className="col-xs-6 col-sm-4 form-group">
              <TableFilterResetButton
                handleClick={() => {
                  setVisibleSearchFields(Object.keys(startingFields));
                  setShowSearchAppliedIcon(false);
                  form.reset();
                  handleReset?.();
                }}
              />
            </div>
            <div className="col-xs-12 col-sm-4 ">
              {showSearchAppliedIcon && (
                <div className="d-flex flex-row">
                  <span id={'checkMark'} className="search-applied" data-testid="search-checkmark" />
                  <label className="search-applied-title-text">{t('tablefilter.icons.searchApplied')}</label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilterForm;
